(function () {
	const siteHeader = document.querySelector("#site-header");

	siteHeader.addEventListener("btToggled", function (e) {
		// e.detail.isActive
		siteHeader.classList.toggle("active");

		if (e.detail.isActive) {
		} else {
		}
	});

	document
		.querySelector("#main-menu")
		.querySelectorAll(".menu-item-has-children")
		.forEach((menuItem) => {
			const menuItemLink = menuItem.querySelector("a");
			const subMenu = menuItem.querySelector(".sub-menu");
			const randomId = "bt-" + Math.floor(Math.random() + Date.now() * 100);

			menuItemLink.setAttribute("aria-controls", randomId);
			subMenu.id = randomId;

			menuItemLink.addEventListener("click", (e) => {
				e.preventDefault();
				menuItemLink.classList.toggle("active");
				subMenu.classList.toggle("active");
				const isActive = menuItemLink.classList.contains("active");

				if (isActive) {
					subMenu.removeAttribute("hidden");
					subMenu.style.transition = "all 0.3s ease";
					subMenu.style.maxHeight = subMenu.scrollHeight + "px";
					subMenu.style.marginTop = "1rem";
				} else {
					subMenu.style.maxHeight = null;
					subMenu.style.marginTop = "0";

					subMenu.addEventListener(
						"transitionend",
						() => {
							subMenu.setAttribute("hidden", "");
						},
						{ once: true }
					);
				}
			});

			menuItem.querySelectorAll(".sub-menu *").forEach((link) => {
				if (link.matches("button, a")) {
					// console.log(link);

					link.setAttribute("tabindex", "-1");
				}
			});
		});
})();
